<template>
  <div>
    <div class="image-container" v-bind:style="backgroundImage"></div>
    <div class="container">
      <div class="row">
        <div class="col text-right my-auto top-col">
          <button v-on:click="showShareModal" class="btn btn-secondary share-button">
          <i class="fa fa-share-alt" aria-hidden="true"></i>Share
          </button>
          <i v-if="isAdmin" v-on:click="showPostModal" class="far fa-edit"></i>
          <i v-if="isAdmin" v-on:click="showDeleteModal" class="far fa-trash-alt"></i>
        </div>
      </div>
      <div class="row">
        <div class="col title-section">
          <h1>{{ title }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col info-section">
          <p>{{ authorName }}: {{ timestamp }}</p>
        </div>
      </div>
      <div class="row">
        <div v-html="postHTML" class="col content-section"></div>
      </div>
    </div>
    <b-modal id="delete-modal" ref="deleteModal" size="lg" hide-footer>
      <div slot="modal-header" class="w-100 justify-content-center post-modal-header">
        <h3>DeletePost</h3>
        <button v-on:click="hideDeleteModal" class="close d-inline" type="button" aria-label="Close">x</button>
      </div>
      <div class="container">
        <p>Are you sure you want to delete this post?</p>
      </div>
      <div class="row">
        <div class="col-md-6">
          <button v-on:click="hideDeleteModal" class="btn btn-secondary">Cancel</button>
        </div>
        <div class="col-md-6">
          <button v-on:click="deletePost" class="btn btn-primary">Delete</button>
        </div>
      </div>
    </b-modal>
    <post-modal ref="postModal"></post-modal>
    <b-modal id="shareModal" ref="shareModal" size="lg" hide-footer>
      <div slot="modal-header" class="w-100 justify-content-center share-modal-header">
        <h3>Share This Business</h3>
        <button v-on:click="hideShareModal" class="close d-inline" type="button" aria-label="Close">x</button>
      </div>
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="exampleInputEmail1">Your Email Address</label>
              <input type="email" v-model="respondTo" class="form-control" aria-describedby="emailHelp" placeholder="Enter email">
            </div>
            <div class="form-group">
              <label for="exampleInputEmail1">Share Email Address</label>
              <input type="email" v-model="sendTo" class="form-control" aria-describedby="emailHelp" placeholder="Enter email">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <button v-on:click="hideShareModal" class="btn btn-secondary">Cancel</button>
          </div>
          <div class="col-md-6">
            <button v-on:click="share" class="btn btn-primary">Submit</button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import router from '../../router/index.js'
import PostModal from './PostModal.vue'
import { mapGetters } from 'vuex'
import Showdown from 'showdown'

export default {
  metaInfo () {
    return {
      title: this.title,
      meta: [
        { vmid: 'description', content: this.description }
      ]
    }
  },
  mounted () {
    this.getPost()
  },
  components: {
    PostModal
  },
  data () {
    return {
      blogImage: null,
      description: null,
      post: null,
      timestamp: null,
      title: null,
      titleImage: null,
      postId: null,
      authorName: null,
      userId: null,
      respondTo: null,
      sendTo: null
    }
  },
  computed: {
    ...mapGetters([
      'getCognitoId'
    ]),
    ...mapGetters('user', [
      'getUserType'
    ]),
    ...mapGetters('business', [
      'getBusinessId'
    ]),
    postHTML () {
      var converter = new Showdown.Converter()
      return converter.makeHtml(this.post)
    },
    backgroundImage () {
      if (this.userId && this.blogImage) {
        return 'background-image: url("https://s3.' +
          window.CONFIG.Region +
          '.amazonaws.com/' +
          window.CONFIG.PhotoBucketName +
          '/xlarge/' +
          this.userId +
          '/' +
          this.blogImage +
          '")'
      } else {
        return null
      }
    },
    backgroundImageUrl () {
      if (this.blogImage) {
        return 'https://s3.' +
          window.CONFIG.Region +
          '.amazonaws.com/' +
          window.CONFIG.PhotoBucketName +
          '/xlarge/' +
          this.userId +
          '/' +
          this.blogImage
      } else {
        return null
      }
    },
    isAdmin () {
      if (this.getUserType === 'user') return (this.userId === this.getCognitoId.split(':')[1])
      if (this.getUserType === 'business') return (this.userId === this.getBusinessId)
    }
  },
  methods: {
    hideDeleteModal () {
      this.$refs.deleteModal.hide()
    },
    showDeleteModal () {
      this.$refs.deleteModal.show()
    },
    showPostModal () {
      this.$refs.postModal.$refs.postModal.show()
    },
    hideShareModal () {
      this.$refs.shareModal.hide()
    },
    showShareModal () {
      this.$refs.shareModal.show()
    },
    validateEmail (email) {
      var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!emailRegex.test(email)) {
        return true
      } else {
        return false
      }
    },
    async share () {
      if (this.validateEmail(this.respondTo)) return
      if (this.validateEmail(this.sendTo)) return
      // if (!this.message) return
      var client = this.$store.getters.getEmailApigClientFactory
      var params = {}
      var pathTemplate = '/shareblog'
      var method = 'POST'
      var additionalParams = {}
      var body = {
        respond_to: this.respondTo,
        send_to: this.sendTo,
        blog_image_url: this.backgroundImageUrl,
        blog_title: this.title,
        blog_description: this.description,
        blog_url: window.location.href
      }
      try {
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.hideShareModal()
      } catch (error) {
        console.log(error)
      }
    },
    async getPost () {
      var client = this.$store.getters.getBlogApigClientFactory
      var params = {
        id: this.$route.params.entry
      }
      var pathTemplate = '/blog/{id}'
      var method = 'GET'
      var additionalParams = {}
      var body = {}
      try {
        var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.blogImage = result.data.blog_image
        this.description = result.data.description
        this.post = result.data.post
        var options = { year: 'numeric', month: 'long', day: 'numeric' }
        this.timestamp = new Date(result.data.timestamp).toLocaleDateString('en-US', options)
        this.title = result.data.title
        this.titleImage = result.data.title_image
        this.postId = result.data.post_id
        this.authorName = result.data.author_name
        this.userId = result.data.user_id
      } catch (error) {
        console.log(error)
      }
    },
    async deletePost () {
      var client = this.$store.getters.getBlogApigClientFactory
      var params = {}
      var pathTemplate = '/blog'
      var method = 'DELETE'
      var additionalParams = {}
      var body = {
        post_id: this.postId,
        userType: this.getUserType
      }
      try {
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        router.push('/insights')
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped>
.top-col {
  padding-top: 1rem;
}

.image-container {
  height: 50vh !important;
  background-size: cover;
  background-position: center center !important;
}

.title-section {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.far {
  font-size: 1.5rem;
  cursor: pointer;
  margin-left: .5rem;
}

.close {
  position: absolute;
  text-shadow: none;
  right: 1rem;
  top: 1rem;
  opacity: 1;
}

.btn-secondary {
  width: 100% !important;
}

.fa {
  margin-right: .6rem;
}

.share-button {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/insights/Entry.vue